import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

const { cinzaSebrae75 } = BaSeTheme.colors.institucionais;
const { white } = BaSeTheme.colors.defaultColors;

export const ButtonsDnD = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const Divisor = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  overflow: visible;
  position: relative;
  background-color: #e0e5eb;
`;

export const WrapperInputColor = styled.div`
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  div {
    button {
      background-color: transparent;
      min-width: 39px;
      min-height: 39px;
      padding: unset;
      margin: auto 16px;
      border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae75};
      box-shadow: none;
      div {
        border: 1px solid rgb(118, 118, 118);
      }
    }
    button:disabled {
      background-color: lightgray;
      color: gray;
      cursor: not-allowed;
    }
    input {
      display: none;
    }
    fieldset {
      display: none;
    }
  }
`;

export const WrapperNotFound = styled.div`
  margin: 36px auto;
  width: 310;
  text-align: center;
`;

export const ContentCodeHtml = styled.div`
  margin-top: 10px;
  display: grid;
  gap: 16px;
`;

export const InputCodeHtml = styled.div`
  border: 1px solid ${cinzaSebrae75};
  border-radius: 5px;
  padding: 4px;
`;

export const WrapperThemeInput = styled.div`
  display: grid;
  gap: 16px;
`;


export const WrapperActionButtons = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
`;

export const WrapperInfo = styled.div`
  display: grid;
  gap: 10px;
`;

export const ContentTemplate = styled.div`
  display: grid;
  gap: 16px;
  background: ${white};
`;

export const WrapperInput = styled.div`
  display: flex;
  place-items: end;
`;

export const ContentComposition = styled.div`
  display: flex;
  gap: 24px;
`;

export const WrapperPageTemplate = styled.div`
  display: grid;
  gap: 24px;
`;

export const ContentViewerPdf = styled.div`
  margin: 16px;
  height: 100%;
`;
